import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { ChipAvatar } from '@treelab/panda';

import { IRootState } from '../../../modules/stores';
import { Container } from './styled';
import { createUnknownUser, isAnonymousUser } from '../../../helpers/user';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps extends WrappedComponentProps {
  className?: string;
  userIds: string[] | null;
}

const Collaborators: React.FC<IConnectProps & IProps> = ({
  className,
  userIds,
  users,
  intl: { formatMessage },
}) => {
  return (
    <Container className={className}>
      {(userIds || []).map((userId: string, index: number) => {
        const user =
          users[userId] || createUnknownUser(userId, formatMessage({ id: 'global.unknown.user' }));

        return (
          <ChipAvatar
            key={`${user.nickName}-${index}`}
            name={user.nickName}
            color={user.color}
            image={user.image}
            isAnonymous={isAnonymousUser(user.id)}
            css={`
              margin-right: 4px;
              margin-bottom: 4px;
            `}
          />
        );
      })}
    </Container>
  );
};

const mapState = ({ core }: IRootState) => ({
  users: core.users,
});

export default compose(injectIntl, connect(mapState))(Collaborators);
